export const TAG = 'MarginCoverIndicator';

export enum MarginCoverIndicatorTag {
  Good = 'G',
  Red = 'R',
  Amber = 'A'
}
